import { render, staticRenderFns } from "./textlist_2_1.vue?vue&type=template&id=5d338980&scoped=true"
import script from "./textlist_2_1.vue?vue&type=script&lang=js"
export * from "./textlist_2_1.vue?vue&type=script&lang=js"
import style0 from "./textlist_2_1.vue?vue&type=style&index=0&id=5d338980&prod&scoped=true&lang=scss"
import style1 from "./textlist_2_1.vue?vue&type=style&index=1&id=5d338980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d338980",
  null
  
)

export default component.exports